/**
 * Script de diagnóstico simple para verificar el estado del sistema
 */

export const simpleDebug = async () => {
  try {
    console.log('🔍 === DIAGNÓSTICO SIMPLE ===');
    
    // 1. Verificar window.auth
    if (!window.auth) {
      console.error('❌ window.auth no disponible');
      return;
    }
    console.log('✅ window.auth disponible');

    // 2. Verificar usuario
    const auth = window.auth.auth;
    const user = auth.currentUser;

    if (!user) {
      console.error('❌ Usuario no autenticado');
      return;
    }
    console.log('✅ Usuario autenticado:', user.uid);

    // 3. Verificar categorías directamente
    console.log('\n📂 Verificando categorías...');
    const { collection, getDocs } = window.auth;
    const categoriesRef = collection(window.auth.db, 'users', user.uid, 'categories');
    const categoriesSnapshot = await getDocs(categoriesRef);
    
    console.log('📊 Categorías encontradas:', categoriesSnapshot.size);
    const categories = categoriesSnapshot.docs.map((doc: any) => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log('📋 Categorías:', categories.map((cat: any) => `${cat.name} (enabled: ${cat.enabled})`));

    // 4. Verificar productos en cada categoría
    console.log('\n📦 Verificando productos...');
    let totalProducts = 0;
    
    for (const category of categories) {
      const standardizedId = getStandardizedId(category.name);
      console.log(`\n🔍 Categoría: ${category.name} -> ID: ${standardizedId}`);
      
      const productsRef = collection(window.auth.db, 'users', user.uid, 'categories', standardizedId, 'stock');
      const productsSnapshot = await getDocs(productsRef);
      
      console.log(`  📊 Productos: ${productsSnapshot.size}`);
      totalProducts += productsSnapshot.size;
      
      if (productsSnapshot.size > 0) {
        productsSnapshot.docs.forEach((doc: any) => {
          const data = doc.data();
          console.log(`    📦 ${doc.id}: ${data.name}`);
          console.log(`      - Variantes: ${data.variants?.length || 0}`);
          if (data.variants && data.variants.length > 0) {
            data.variants.forEach((variant: any, index: number) => {
              console.log(`      - Variante ${index + 1}: ${variant.color}`);
              if (variant.images) {
                Object.entries(variant.images).forEach(([type, url]) => {
                  if (url) {
                    console.log(`        - ${type}: ${url}`);
                  }
                });
              }
            });
          }
        });
      }
    }

    console.log(`\n📊 Total productos: ${totalProducts}`);

    // 5. Probar servicio directamente
    console.log('\n🔧 Probando servicio...');
    try {
      const inventoryService = (await import('../services/inventoryService')).default;
      console.log('✅ inventoryService importado');
      
      const products = await inventoryService.getProductsFromDocumentedStructure();
      console.log(`📦 Productos desde servicio: ${products.length}`);
      
      if (products.length > 0) {
        console.log('📋 Primer producto:', {
          id: products[0].id,
          name: products[0].name,
          category: products[0].category,
          imageURL: products[0].imageURL
        });
      }
    } catch (error) {
      console.error('❌ Error con servicio:', error);
    }

    console.log('\n✅ Diagnóstico completado');
    
    return {
      success: true,
      categories: categories.length,
      totalProducts: totalProducts,
      user: user.uid
    };

  } catch (error) {
    console.error('❌ Error en diagnóstico:', error);
    return {
      success: false,
      error: error
    };
  }
};

// Función auxiliar
const getStandardizedId = (categoryName: string): string => {
  const mapping: Record<string, string> = {
    'CAMPERA': 'campera',
    'BUZO': 'buzo',
    'CAMISA': 'camisa',
    'REMERA': 'remera',
    'PANTALÓN': 'pantalon',
    'POLLERA': 'pollera',
    'VESTIDO': 'vestido',
    'PAÑUELO': 'pañuelo',
    'SOMBRERO, GORRA, GORRO': 'sgg',
    'CALZADO': 'calzado'
  };
  return mapping[categoryName] || categoryName.toLowerCase().replace(/[^a-z0-9]/g, '');
};

// Hacer disponible en consola
if (typeof window !== 'undefined') {
  (window as any).simpleDebug = simpleDebug;
}